/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OperationTypeViewModel } from '../../models/operation-type-view-model';

export interface GetOperationTypes$Params {
}

export function getOperationTypes(http: HttpClient, rootUrl: string, params?: GetOperationTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OperationTypeViewModel>>> {
  const rb = new RequestBuilder(rootUrl, getOperationTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OperationTypeViewModel>>;
    })
  );
}

getOperationTypes.PATH = '/api/v1/WorkCenter/GetOperationTypes';
